import { render } from "./BasePhotoStack.vue?vue&type=template&id=12b4760a"
import script from "./BasePhotoStack.vue?vue&type=script&lang=js"
export * from "./BasePhotoStack.vue?vue&type=script&lang=js"

import "./BasePhotoStack.vue?vue&type=style&index=0&id=12b4760a&vars=%7B%20scale%2C%20multiplier%2C%20twoImgs%2C%20big%7D&lang=css"
script.render = render

export default script